import { MonolithLoan } from '@src/data/types/MonolithLoan'
import { getApiClient } from '@src/services/api-client'
import { skipToken, useQuery } from '@tanstack/react-query'

const SCOPE_MONOLITH_LOANS = 'monolithLoans'

const keysFactory = {
  loansByReference: (reference: string) => [SCOPE_MONOLITH_LOANS, reference] as const,
}

const getLoansByReference = async (reference: string) => {
  const response = await getApiClient().get<MonolithLoan[]>(`/MonolithLoans/${encodeURIComponent(reference)}`)
  return response.data
}

export function useMonolithLoansByReference(filters: { search: string | null }) {
  const reference = filters.search?.trim() ?? ''
  return useQuery({
    queryKey: keysFactory.loansByReference(reference),
    queryFn: reference !== '' ? () => getLoansByReference(reference) : skipToken,
  })
}
